import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFolderItemContainer = styled.div<{ $disabled: boolean }>`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 230px;
    padding: 24px;
    cursor: pointer;
    background-color: var(--color-white);
    border-radius: var(--radius-20);
    box-sizing: border-box;
    box-shadow: ${({ disabled }) => disabled ? "none" : "0 2px 2px rgba(0, 0, 0, 0.15)"};
    @media ${breakpoints.xs} {
        width: 136px;
        min-height: 135px;
        padding: 12px;
    }

    svg {
        path {
            fill: var(--color-secondary-light);
        }
        @media ${breakpoints.xs} {
            width: 40px;
            height: 40px;
        }
    }
`;

export const StyledFolderItemLabel = styled.p<{ $isPending: boolean }>`
    margin-top: 15px;
    margin-bottom: ${(props) => (props.$isPending ? "15px" : "0")};
    font-size: var(--size-18);
    font-weight: bold;
    word-break: break-word;
    color: var(--color-primary);
    text-align: center;
    @media ${breakpoints.xs} {
        margin-top: 5px;
        font-size: var(--size-14);
        line-height: 21px;
    }
`;
export const StyledFolderItemWaitingTag = styled.div`
    position: absolute;
    bottom: 14px;
    height: 16px;
    padding: 1px 20px;
    font-size: var(--size-12);
    font-weight: var(--weight-600);
    color: var(--color-primary-fg);
    text-align: center;
    background: var(--color-primary);
    border-radius: var(--radius-20);
    @media ${breakpoints.xs} {
        bottom: 8px;
    }
`;